export default "__VITE_ASSET__DWaiKgl5__"